import axios from '@/libs/axios';

// Mapeia a chave de tamanho usada na grade (itemXxx) para o campo com o cdn_tamanho (itemTamanhoXxx)
const GRADE_TAMANHO_PREFIX = 'itemTamanho';

let tamanhosPromise = null;

/**
 * Carrega (uma única vez) os tamanhos cadastrados em sls_tamanho.
 * Retorna um objeto { [cdn_tamanho]: des_tamanho }.
 */
export function carregarTamanhos() {
  if (!tamanhosPromise) {
    tamanhosPromise = axios.get('/tamanhos?perPage=10000')
      .then((response) => (response.data?.data || []).reduce((acc, t) => {
        acc[String(t.cdn_tamanho)] = t.des_tamanho;
        return acc;
      }, {}))
      .catch((error) => {
        console.error('Erro ao carregar tamanhos: ', error);
        tamanhosPromise = null;
        return {};
      });
  }
  return tamanhosPromise;
}

/**
 * cdn_tamanho de cada tamanho da grade, segundo os campos itemTamanhoXxx devolvidos pela API.
 */
export function cdnTamanhosDaGrade(gradeColor, sizes) {
  return sizes.reduce((acc, size) => {
    acc[size] = gradeColor?.[`${GRADE_TAMANHO_PREFIX}${size}`] || null;
    return acc;
  }, {});
}

/**
 * Descrição exibida para um cdn_tamanho (ex.: 19 -> '33 a 37').
 * Se não houver descrição cadastrada, mantém o texto de fallback.
 * Apenas visual: a chave original da grade continua sendo usada para localizar o SKU.
 */
export function descricaoTamanho(cdnTamanho, tamanhos, fallback = '') {
  return (cdnTamanho && tamanhos?.[String(cdnTamanho)]) || fallback;
}
